import React, { useState, useEffect } from 'react';
import '../CustomersDetails/CustomerMaster/CustomerMaster.css';
import AccidentVehicle from '../AccidentVehicle/AccidentVehicle.css';
import axios from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Helmet } from 'react-helmet-async';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Alert } from '@mui/material';
import ActivationModel from '../../../Component/CompanyAdmin/ActivationModel/ActivationModel';
import DataTable from "react-data-table-component";
import Admin from '../AdminHome/SideBar/Admin';
import { Search, Download } from "lucide-react";
import { exportToExcel } from '../../../Services/exportToExcel';


const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript
};

const EmployeeApproved = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10)
  const [searchQuery, setSearchQuery] = useState('');
  const [isGenerated, setIsGenerated] = useState(false);
  const [generatedExcel, setGeneratedExcel] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [marginLeft, setMarginLeft] = useState('30px');
  const [paddingLeft, setPaddingLeft] = useState('30px');
  const [width, setWidth] = useState('100%');
  const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info', timestamp: null });

  const getDepartment = localStorage.getItem("department");
  console.log("getDepartment", getDepartment)

  const [showEmployeeMasterEdit, setShowEmployeeMasterEdit] = useState(false)
  const [selectedId, setSelectedId] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowsSelected = (state) => {
    setSelectedRows(state.selectedRows);
  }

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some(selected => selected.companyEmpId === row.companyEmpId),
      style: {
        backgroundColor: '#bdb6b6',
      },
    }
  ];

  const tableCustomStyles = {
    headRow: {
      style: {
        color: '#ffff',
        backgroundColor: 'rgb(169 187 169)',
        fontWeight: "bold",
        fontSize: '13px'
      },
    },
    pagination: {
      style: {
        button: {
          background: 'none',
          boxShadow: "none"
        },
      },
    },
    striped: {
      style: {
        default: 'red'
      }
    },
    rows: {
      style: {
        backgroundColor: '#f2f2f2',
      }
    }
  }


  const deactive = async (id, isActivate) => {
    const response = await axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/changeActivationEmployee/${userId}/${id}/${isActivate}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    getData();
    setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
  };


  useEffect(() => {
    if (!showEmployeeMasterEdit) getData();
    console.log("token", token, userId);
    if (token === "" || userId === "") {
      navigate("/");
    }
  }, [token, userId, navigate, showEmployeeMasterEdit]);

  const generateFile = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dBToExcel/${userId}/employee`, { headers: { Authorization: `Bearer ${token}` } });
      console.log("daa", response.data.data)
      console.log("response", response.data.data);
      setGeneratedExcel(response.data.data)
      setIsLoading(false);
      setIsGenerated(true);
    } catch (error) {
      setIsLoading(false);  // Ensure loading state is reset in case of error
      console.error(error.message);
    }
  }

  function view(id) {
    console.log("myId", id)
    setSelectedId(id);
    setShowEmployeeMasterEdit(true)
    navigate("/edit-employee", { state: { id: id } });
  }
  const handleUpdate = () => {
    setShowEmployeeMasterEdit(false); // Hide VendorMasterEdit
  };
  const getData = async (e) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getEmployee/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
    const fetchedData = response.data.data;
    const formattedData = fetchedData.map(item => ({
      ...item,
      DOJ: formatDate(item.DOJ),
    }));
    setData(formattedData);
    setCurrentItems(formattedData);
  };


  const deleteEmployee = async (id) => {
    const response = await axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/deleteEmployee/${userId}/${id}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    getData();
    setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
  };

  const handleConfirmDelete = async (employeeCode) => {
    await deleteEmployee(employeeCode);
    setModalOpen(false);
  }
  const handleCancel = () => {
    setModalOpen(false);
  };
  const openModal = (item) => {
    setModalData(item);
    setModalOpen(true);
  };
  const openDeleteModal = (item) => {
    setDeleteData(item);
    setModalOpen(true);
  }
  const handleConfirm = (employeeCode, isActive) => {
    deactive(employeeCode, isActive);
    setModalOpen(false);
  };


  const [currentItems, setCurrentItems] = useState(data);
  const columns = [
    {
      name: "EmployeeID",
      selector: row => row.id, // Raw data for sorting
      cell: row => <span>{String(row.id).padStart(4, '0')}</span>, // Display formatted value
      sortable: true,
      sortFunction: (rowA, rowB) => rowA.id - rowB.id // Custom sort function
    },
    {
      name: "Date",
      selector: (row) => row.systemDate ? formatDate(row.systemDate) : "____",
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const dateA = new Date(rowA.systemDate);
        const dateB = new Date(rowB.systemDate);
        return dateA - dateB; // Ascending order
      },
    },
    {
      name: "Employee Name", selector: (row) => row.name, sortable: true, width: "150px",
      cell: (row) => (
        <span style={{ color: 'brown' }}>{row.name ? row.name.charAt(0).toUpperCase() + row.name.slice(1) : ""}</span>
      )
    },
    {
      name: "Email Of Employee", selector: (row) => row.employeeEmailId, sortable: true, width: "200px",
      cell: (row) => (
        <a href={`mailto:${row.employeeEmailId}`} style={{ color: "blue", textDecoration: "none" }}>
          {row.employeeEmailId}
        </a>
      ),
    },
    {
      name: "Department", selector: (row) => row.department, sortable: true, width: "150px",
      cell: (row) => (
        <span style={{ color: '#fff', backgroundColor: '#ffc107', padding: '5px', borderRadius: '4px' }}>
          {row.department ? row.department : ""}
        </span>
      ),
    },
    { name: "Gender", selector: (row) => row.gender, sortable: true },
    {
      name: "Added By",
      selector: (row) => row.addedBy || '',
      sortable: true,
      cell: (row) => {
        const addedBy = row.addedBy ? String(row.addedBy) : "";
        return (
          <span style={{ color: "green" }}>
            {row.addedBy ? addedBy.charAt(0).toUpperCase() + addedBy.slice(1).toLowerCase() : ""}
          </span>
        );
      },
    },
    {
      name: "Modified By",
      selector: (row) => row.EditedBy || '',
      sortable: true,
      cell: (row) => {
        const EditedBy = row.EditedBy ? String(row.EditedBy) : "";
        return (
          <span style={{ color: "green" }}>
            {row.EditedBy ? EditedBy.charAt(0).toUpperCase() + EditedBy.slice(1).toLowerCase() : ""}
          </span>
        );
      },
    },

    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => view(row.companyEmpId)}
          className='view-button'
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Performance",
      cell: (row) => (
        <button
          className='view-button'
          style={{ background: '#e6e679' }}
        >
          Performance
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Activate / Deactivate",
      cell: (row) => (
        <button
          onClick={() => openModal(row)}
          className='view-button'
          style={{ background: 'rgb(190 98 98)', color: "white" }}
        >
          {row.isActive === "true" ? "Deactivate" : "Activate"}
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },

  ];

  if (getDepartment !== "Administration") {
    columns.push({
      name: "Delete Employee",
      cell: (row) => (
        <span
          onClick={() => openDeleteModal(row)}
          style={{ cursor: 'pointer' }}
        >
          <DeleteOutlineIcon />
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    });
  }
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(value);

    const newRows = data.filter((row) => {
      const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
      const searchLower = value;

      const idValue = formattedId.includes(searchLower);
      const dateValue = (formatDate(row.systemDate) ?? '').toLowerCase().includes(searchLower);
      const nameValue = (row.name ?? '').toLowerCase().includes(searchLower);
      const emailValue = (row.employeeEmailId ?? '').toLowerCase().includes(searchLower);
      const branchValue = (row.branch ?? '').toLowerCase().includes(searchLower);
      const editedByValue = (row.EditedBy ?? '').toLowerCase().includes(searchLower);
      const genderValue = (row.gender ?? '').toLowerCase().includes(searchLower);

      return idValue || dateValue || nameValue || emailValue || branchValue || editedByValue || genderValue;
    });

    setCurrentItems(newRows);
  };

  // const [searchValue, setSearchValue] = useState('');

  const [filterType, setFilterType] = useState('completed');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSubmit = async () => {
    console.log('handleSubmit calling: ')
    setIsLoading(true);
    setIsGenerated(false);

    console.log({

      filter: filterType,
      from: fromDate,
      to: toDate
    })

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`, {

        filter: filterType,
        from: fromDate,
        to: toDate
      });
      const fetchedData = response.data.data;
      console.log('==============')
      console.log(fetchedData)

      const formattedData = fetchedData.map(item => ({
        ...item,
        systemDate: item.systemDate ? formatDate(item.systemDate) : "",

      }));

      // console.log(formattedData)
      // setData(formattedData);
      setCurrentItems(formattedData);

    } catch (error) {
      console.log(error)
    }


    return
    // 
    try {

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/generate-excel`, {
        search: searchValue,
        filter: filterType,
        from: fromDate,
        to: toDate
      });

      if (response.data && response.data.fileUrl) {
        setGeneratedExcel(response.data.fileUrl);
        setIsGenerated(true);
      } else {
        alert('Excel file generation failed.');
      }
    } catch (error) {
      console.error('Error generating Excel:', error);
      alert('Something went wrong while generating the Excel file.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    // Export only selected rows if any, otherwise export all current items
    const exportData = selectedRows.length > 0 ? selectedRows : currentItems;
    // console.log(currentItems)
    exportToExcel(exportData, "Report");
  };



  return (
    <div style={{marginTop: "-20px"}}>
      <Admin />
      {!showEmployeeMasterEdit && (<div className="Customer-master-form" style={{ marginLeft: '10px', paddingLeft: '0px', marginRight: '10px', paddingRight: '0px' }}>
        <Helmet>
          <title>Employee Information - Claimpro</title>
          <meta name="description" content="Employee Information For Claimpro Assist" />
          <meta name="keywords" content="Vehicle Accidents, accident trucks,  Customer Service, Claimpro, Claim pro Assist, Claimpro Assist ,Accidental repair ,Motor Insurance claim,Advocate services ,Crane service ,On site repair,Accident Management" />
          <link rel='canonical' href={`https://claimpro.in/EmployeeApproved`} />
        </Helmet>

        <div style={{marginTop: "-35px"}}>
          <h3 className="bigtitle ms-5 container">Employee View / Edit</h3>

          <div className='container ms-5 mt-3' >
            <style>
              {`
                                                           .form-search {
                                                               display: flex;
                                                               flex-wrap: wrap;
                                                               gap: 10px;
                                                           }
               
                                                           @media (max-width: 768px) {
                                                               .form-search {
                                                               gap: 3px;
                                                               //   padding-right: 25px; /* ✅ Add spacing on right side */
                                                               margin-right: 25px; /* ✅ Add spacing on right side */
                                                               //   padding-left: -5px;  /* (Optional) to center more nicely */
                                                               }
               
                                                               .form-search > div {
                                                               flex: 1 1 100% !important;
                                                               min-width: 100% !important;
                                                               }
                                                           }
                                               `}
            </style>

            {/* below hidden div is unused, can be removed */}
            <div hidden className="form-search">
              {/* Search */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Search by
                  <input
                    type="search"
                    className="form-control-sm border ps-3"
                    placeholder="Search"
                    // value={searchValue}
                    onChange={handleSearch}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Filter Dropdown */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Filter:
                  <select
                    className="form-control-sm border ps-2"
                    // value={filterType}
                    // onChange={e => setFilterType(e.target.value)}
                    style={{ width: '100%' }}
                  >
                    <option value="completed">Completed</option>
                    <option value="pre-canceled">Pre-canceled</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </label>
              </div>

              {/* From Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  From:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={fromDate}
                    // onChange={e => setFromDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* To Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  To:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={toDate}
                    // onChange={e => setToDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Generate/Download Excel Button */}
              <div style={{ flex: '1 1 200px', minWidth: '200px', marginTop: "10px" }}
              // onClick={handleSubmit}
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              >
                <label className="label-class" style={{ width: '100%', display: 'block' }}>
                  &nbsp; {/* Placeholder to align */}

                  <a
                    // href={generatedExcel}
                    onClick={handleSubmit}
                    className="form-control download-link"
                    style={{ textAlign: 'center' }}
                  >
                    Search
                  </a>

                </label>
              </div>
            </div>

            <div >
              {/* Embedded CSS for responsiveness */}
              <style>
                {`
                   .form-search {
                     display: flex;
                     flex-wrap: wrap;
                     gap: 10px;
                   }
                 
                   @media (max-width: 768px) {
                     .form-search {
                       gap: 3px;
                     //   padding-right: 25px; /* ✅ Add spacing on right side */
                       margin-right: 25px; /* ✅ Add spacing on right side */
                     //   padding-left: -5px;  /* (Optional) to center more nicely */
                     }
                 
                     .form-search > div {
                       flex: 1 1 100% !important;
                       min-width: 100% !important;
                     }
                   }
                 `}
              </style>


              {/* <h3 className="bigtitle">Sign-up Vendor</h3> */}

              <div className="form-search flex">

                {/* Search */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Search by
                    <input
                      type="search"
                      className="form-control-sm border ps-3"
                      placeholder="Search"
                      // value={searchValue}
                      onChange={handleSearch}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Filter Dropdown */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Filter:
                    <select
                      className="form-control-sm border ps-2"
                      value={filterType}
                      onChange={e => setFilterType(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <option value="completed">Completed</option>
                      <option value="pre-cancelled">Pre-cancelled</option>
                      <option value="post-cancelled">Cancelled</option>
                    </select>
                  </label>
                </div>

                {/* From Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    From:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={fromDate}
                      onChange={e => setFromDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* To Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    To:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={toDate}
                      onChange={e => setToDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Buttons */}
                <div className='flex  gap-2 '>

                  {/* <Search
                         className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-gray-600"
                       />
     
                       <Download
                         className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-blue-600"
                       /> */}

                  <button onClick={handleSubmit}>
                    <Search className="w-6 h-6 text-gray-600" />
                  </button>
                  <button onClick={handleExport}>
                    <Download className="w-6 h-6 text-gray-600" />
                  </button>
                </div>

              </div>

            </div>

          </div>

        </div>

        {alertInfo.show && (
          <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
            {alertInfo.message}
          </Alert>
        )}

        <div className="container d-flex justify-content-center " >
          <div className="container-for-tables my-4">
            <DataTable
              columns={columns}
              data={currentItems}
              fixedHeader
              pagination
              selectableRows
              onSelectedRowsChange={handleRowsSelected}
              conditionalRowStyles={conditionalRowStyles}
              customStyles={tableCustomStyles}
            />
          </div>
        </div>

        {/* <div className='pagination'>
        <ButtonGroup style={{boxShadow:'none'}} variant="contained" color="primary" aria-label="pagination buttons">
          <Button onClick={handlePreviousPage} disabled={currentPage === 1}><ArrowBack /></Button>
          {pageNumbers.map((pageNumber) => (
            <Button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={currentPage === pageNumber ? 'active' : ''}
            >
              {pageNumber}
            </Button>
          ))}
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}><ArrowForward /></Button>
        </ButtonGroup>
      </div> */}

        {modalData && (
          <ActivationModel
            isOpen={isModalOpen}
            onConfirm={() => handleConfirm(modalData.companyEmpId, modalData.isActive === "true" ? "false" : "true")}
            onCancel={handleCancel}
          />
        )}

        {deleteData && (
          <ActivationModel
            isOpen={isModalOpen}
            onConfirm={() => handleConfirmDelete(deleteData.companyEmpId)}
            onCancel={handleCancel}
          />
        )}
      </div>)}

      {/* {showEmployeeMasterEdit && (
      <EmployeeFormEdit id={selectedId} onUpdate={handleUpdate}/>
    )} */}
    </div>
  );

};

export default EmployeeApproved;
